import {cn} from '@/lib/utils'

export function KairosMark({className, size = 'sm'}: {className?: string; size?: 'sm' | 'lg'}) {
  const dims = size === 'lg' ? 'h-8 w-14' : 'h-4 w-6'
  const dot = size === 'lg' ? 'h-3 w-3' : 'h-[7px] w-[7px]'

  return (
    <span className={cn('relative inline-flex shrink-0 items-center', dims, className)}>
      <span className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-current opacity-35" />
      <span
        className={cn('absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-current', dot)}
      />
    </span>
  )
}
